import { Route, Routes } from 'react-router-dom'
import SupplierDetailsPage from './pages/supplier-details'
import { Container } from '@/shared/components'
import useI18n from '@/shared/hooks/usei18n'
import SuppliersList from './components/SuppliersList'
import { useGetAllPartnerships } from '@/features/suppliers/hooks/partnerships'
import { useSession } from '@/shared/hooks/useSession'
import useDialog from '@/common/hooks/useDialog'
import SupplierCreateDialog from './dialogs/SupplierCreateDialog'
import { Button, H2 } from '@/common'

export default function Suppliers() {
  return (
    <Routes>
      <Route path="/:partnershipId">
        <Route index path="*" element={<SupplierDetailsPage />} />
      </Route>
      <Route path="/" element={<SuppliersListPage />} />
    </Routes>
  )
}

function SuppliersListPage() {
  const { t } = useI18n()
  const organizationId = useSession().session.organization.id
  const {
    open: openCreateSupplier,
    openDialog: openCreateSupplierDialog,
    closeDialog: closeCreateSupplierDialog
  } = useDialog()

  const suppliersData = useGetAllPartnerships(organizationId)
  const suppliers = suppliersData.data ?? []
  const offPlatformSuppliers = suppliers.filter(supplier => supplier.isOffPlatform)

  return (
    <Container>
      <header className="flex justify-between items-start">
        <H2>{t('suppliers:suppliersPage.title')}</H2>
        {offPlatformSuppliers.length > 0 && (
          <Button onClick={openCreateSupplierDialog}>
            {t('suppliers:suppliersPage.suppliersList.noSuppliers.action')}
          </Button>
        )}
      </header>
      <SuppliersList
        suppliers={offPlatformSuppliers}
        organizationId={organizationId}
        missingResourcesAction={{
          label: t('suppliers:suppliersPage.suppliersList.noSuppliers.action'),
          onClick: openCreateSupplierDialog
        }}
      />
      <SupplierCreateDialog
        isOpen={openCreateSupplier}
        close={closeCreateSupplierDialog}
        organizationId={organizationId}
      />
    </Container>
  )
}
